import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Document } from '@app/modules/core/store/models/document.model';

export const HorizonRatingsActions = createActionGroup({
  source: 'Horizon Ratings',
  events: {
    'Show Expanded View': props<{ datasetUId: string; selectedOverviewDocument: Document; loadRatingsDocuments: boolean }>(),
    'Hide Expanded View': emptyProps(),
    'Load Ratings Documents': props<{ datasetUId: string; selectedOverviewDocument: Document }>(),
    'Load Ratings Documents Success': props<{ ratingsDocuments: Document[] }>(),
    'Load Ratings Documents Error': props<{ error: Error }>(),
    'Reset State': emptyProps()
  }
});
